import type { IconName } from '@tutero/ui';

/** A heading in the nav, and on Home. */
export interface Section {
  id: string;
  title: string;
}

/**
 * The nav's headings, in the order it draws them (`manifests-draw-the-nav` D2): the
 * Flutter admin's five (`admin-app/lib/src/presentation/layout/sidebar.dart`), and Schools,
 * which it never had. A manifest's `section` is one of these ids, so a typo is a compile
 * error and the order is one list a reader can see rather than a number spread over forty
 * files.
 *
 * `access` is gone with the one tool it held (`permissions-is-in-the-profile` D5): a
 * heading nothing can draw is a promise the nav never keeps, and the live admin never
 * had this one. `analytics` went the same way with Commercial Analytics: Charts, in
 * Vibes, is where the analytics are now.
 */
export const SECTIONS = [
  { id: 'agents', title: 'Agents' },
  { id: 'users', title: 'Tutoring Users' },
  { id: 'operations', title: 'Operations' },
  { id: 'vibes', title: 'Vibes' },
  { id: 'schools', title: 'Schools' },
  { id: 'learning-backend', title: 'Learning Backend' },
] as const satisfies readonly Section[];

export type SectionId = (typeof SECTIONS)[number]['id'];

/** A section the nav draws as one row, its tools the tabs of that row's page. */
export interface SectionPage {
  section: SectionId;
  /** The heading the row sits under. */
  within: SectionId;
  /** Its place among that heading's rows, on the same scale as a manifest's `order`. */
  order: number;
  icon: IconName;
}

/**
 * The sections that are one page (`learning-backend-is-one-page` D1, D2). The section stays:
 * its manifests still name it, and Page access still groups its grants under it.
 */
export const SECTION_PAGES: readonly SectionPage[] = [
  {
    section: 'learning-backend',
    within: 'operations',
    order: 30,
    icon: 'school',
  },
];
